import { useAppSelector } from 'core/store/hooks';
import { salPlanningSelector } from '../../_redux/selectors';
import { useEffect, useState } from 'react';
import { RptSalPlannedMeseAnnoImportoOutputDto, RptSalPlannedOutputDto, RptSalPlannedTotaleMeseDto } from '@api/client';

const useGetSalPlanning = () => {
  const salPlanning = useAppSelector(salPlanningSelector);
  const [projects, setProjects] = useState<RptSalPlannedOutputDto[]>([]);
  const [allMonths, setAllMonths] = useState<any[]>([]);
  const [totaliMese, setTotaliMese] = useState<RptSalPlannedTotaleMeseDto[]>([]);
  const [totaleGenerale, setTotaleGenerale] = useState<number | undefined>(undefined);

  const getAllMonths = (projects: RptSalPlannedOutputDto[]) => {
    let allMonths: any[] = [];
    projects.forEach((project) => {
      project.rptSalPlannedMeseAnnoImportoOutputDtoList?.forEach((month) => {
        if (!allMonths.find((m) => m.month === month.mese && m.year === month.anno)) {
          allMonths.push({ month: month.mese, year: month.anno });
        }
      });
    });
    allMonths.sort((a, b) => {
      if (a.year === b.year) {
        return a.month - b.month;
      }
      return a.year - b.year;
    });
    setAllMonths(allMonths);
    return allMonths;
  };

  const getMappedUsers = (projects: RptSalPlannedOutputDto[]) => {
    const allMonths = getAllMonths(projects);
    const mappedUsers = projects.map((project) => {
      let projecMonthYear: RptSalPlannedMeseAnnoImportoOutputDto[] = [];
      allMonths.forEach((month) => {
        const userMonth = project.rptSalPlannedMeseAnnoImportoOutputDtoList?.find(
          (m) => m.mese === month.month && m.anno === month.year
        );
        if (!userMonth) {
          projecMonthYear.push({
            mese: month.month,
            anno: month.year,
            salImporto: 0,
          });
        } else {
          projecMonthYear.push({ ...userMonth });
        }
      });
      projecMonthYear.sort((a, b) => {
        if (a.anno === b.anno) {
          return (a.mese ?? 0) - (b.mese ?? 0);
        }
        return (a.anno ?? 0) - (b.anno ?? 0);
      });
      return { ...project, rptSalPlannedMeseAnnoImportoOutputDtoList: projecMonthYear };
    });
    return { userList: mappedUsers };
  };

  useEffect(() => {
    if (salPlanning) {
      const { userList } = getMappedUsers(salPlanning.results || []);
      setProjects(userList);
      setTotaliMese(salPlanning.totaliMese || []);
      setTotaleGenerale(salPlanning.totaleGenerale);
    }
  }, [salPlanning]);

  return { projects: projects || [], allMonths, setProjects, totaliMese, totaleGenerale };
};

export default useGetSalPlanning;
